import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { UnosStatusComponent } from '../unos-status/unos-status.component';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
	loading : boolean = false; 
	currentView = 'main';
	kategorije : any = [];
	idTipaPrijave : any = null;
	prijave : any = [];
	novaPrijavaDom : boolean = true; 
	odabraniDomId : any = null;
	prekoPortala = false;
	//old
	prijaveskola : any = [];
	prijavesrednjaskola : any = [];
	prijavepredskolsko : any = [];
	prijavefakultet : any = [];
	odabranaPrijava : any = null;
	odabranaPrijavaTabela : any = null;
	zakaziPrijava : any = null;
	novaPrijavaSkola : boolean = true; 
	odabraniId : any = null;
	novaPrijavaVrtic : boolean = true;
	novaPrijavaPrviSrednje : boolean = true; 
	odabraniVrticPrijavaId : any = null;
	dodataPrijavaSkola : any = null;
	odabraniPrviSrednjeId : any = null;
	nazivKategorije : any = null; 

	odabranaPrijavaDom : any = null;
	prijavadomponisti : any = null;
	prijavadomobradi : any = null;
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	modalInstance : any = null;
	jedinice : any = [];
	statusi : any = [];

	constructor(public globalSrvc: GlobalService, public http : HttpClient, private route: ActivatedRoute, public router: Router) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
		}, 1000);

		this.ucitajKategorije();	
	}

	ucitajKategorije(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'prijave/domovi/kategorije', {params: {}})
			.subscribe(data => {
				this.kategorije = data;
				this.loading = false;

				setTimeout(() => {
					let elems = document.querySelectorAll('.tooltipped');
            		let instances = M.Tooltip.init(elems, {});    
				}, 1000);

				if (this.kategorije.length > 0){					
					this.idTipaPrijave = this.kategorije[0].id;
					this.ucitajKandidate();
				}
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	rList : any = null;

	kategorijeSelected(event){
		this.ucitajKandidate();
	}

	jeSrednja(){
		if (this.idTipaPrijave == '1' || this.idTipaPrijave == '2')
			return true; 
		else 
			return false; 
	}

	ucitajKandidate(){
		this.loading = true; 
		this.sortOption = 1;

		this.http.get(this.globalSrvc.rootUrl + 'prijave/dom/admin/ranglista', {params: {idTipaPrijave : this.idTipaPrijave}})
		.subscribe(data => {
			if (data){
				this.rList = data;
				this.prijave = this.rList.kandidati;
				//console.log(this.prijave);
				this.initTooltips();
			}
			this.loading = false;
		},
		error => {
			this.loading = false;
		});
	}

	getBodoviLuca(luca){
		if (!luca)
		 	return '';
		
		if (luca == 1)
		 	return 10;
		if (luca == 2)
			return 5;

		return '';
	}

	getBodoviPorStatus(value){
		if (value == '1') return '5';
		else return '';
	}

	getOcjenaExterna(extocjena){
		if (!extocjena)
		 	return '';
		
		return extocjena;
	}

	getBodoviTakmicenja(bodovi){
		if (!bodovi)
			return '';

		if (bodovi == '2')
			return 'I';

		if (bodovi == '1')
			return 'II';
		
		return '';
		
	}

	getStepenStudija(stepen){
		if (!stepen)
			return '';

		if (stepen == 'O')
			return 'Osnovne';

		if (stepen == 'M')
			return 'Master';
		
		return '';
		
	}

	dodajPrijavuDom(){
		if (!this.idTipaPrijave){
			M.toast({html:'Odaberite kategoriju prijave', displayLength : 4000});
			return; 
		}
		let item = this.kategorije.find((x) => x.id == this.idTipaPrijave);		
		if (item) this.nazivKategorije = item.naziv;

		this.novaPrijavaDom = true;
		this.odabraniDomId = null;
		this.prekoPortala = false;
		this.currentView = 'dom';
		//this.router.navigate(["prijavaPage"]);
	}

	brmjesta(){
		this.currentView = 'brmjesta';
	}

	nijeAbonent(){
		if (this.idTipaPrijave == '5' || this.idTipaPrijave == '6')
			return false; 
		else 
			return true;
	}

	getNazivStudPrograma(){
		let item = this.kategorije.find((item) => item.id == this.idTipaPrijave);

		if (!item)
			return '';

		return item.naziv;
	}

	onInsertDom(data){
		this.currentView = 'main';
		var elem = document.getElementById('modal10');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {this.ucitajKandidate();}});
		instance.open();
	}

	pregled(prijava){
		this.novaPrijavaDom = false;
		this.odabraniDomId = prijava.id;
		this.currentView = 'dom';
		this.prekoPortala = prijava.prekoPortala; 
	}

	ponistiprijavu(prijava){
		this.prijavadomponisti = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal7');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}

	obradiprijavu(prijava){
		this.prijavadomobradi = prijava; 
		this.currentView = 'main';
		var elem = document.getElementById('modal9');				
		var instance = M.Modal.init(elem, {onCloseEnd : () => {}});
		instance.open();
	}
	
	server_data : any; 

	ucitajJedinice() {	
		this.loading = true;
		this.http.get('prijave/statusi/liste', { params: { idTipa : this.idTipaPrijave } })
			.subscribe(data => {
				//console.log(data);
				this.loading = false;
				this.server_data = data;	
				
				this.jedinice = this.server_data.jedinice;
				this.statusi = this.server_data.statusi;
				this.openUnosStatusModal();
			}
			, error => {
				this.loading = false;
			});	
	}

	openUnosStatusModal(){
		var elem = document.getElementById('modalStatus');					
		this.modalInstance = M.Modal.init(elem, {onCloseEnd : () => {console.log('destroy'); this.modalInstance.destroy();}});
		this.modalInstance.open();
		//this.modalRef.ucitaj();
	}

	onInsertUpsjeh(data){
		let item = this.prijavesrednjaskola.find((item) => item.id == data.id);
		
		if (item)
			item.uspjehDef = '1';

		this.currentView = 'main';
		var elem = document.getElementById('modal2');				
		var instance = M.Modal.init(elem, {});
		instance.open();
		this.initTooltips();
	}

	onInsertUspjehFakultet(data){
		let item = this.prijavefakultet.find((item) => item.id == data.id);
		
		if (item)
			item.uspjehDef = '1';

		this.currentView = 'main';
		var elem = document.getElementById('modal10');				
		var instance = M.Modal.init(elem, {});
		instance.open();
		this.initTooltips();
	}

	onInsertStatus(event){
		this.ucitajKandidate();
		if (this.modalInstance)
			this.modalInstance.destroy();
	
		this.initTooltips();
	}

	onCancel(data){
		this.currentView = 'main';
		this.initTooltips();
	}

	initTooltips(){
		setTimeout(() => {
			let elems = document.querySelectorAll('.tooltipped');
            let instances = M.Tooltip.init(elems, {});    
		}, 500);
	}

	msg : any = null;

	ponistiPrijavuDomPotvrda(){
		let url = 'prijave/admin/dom/ponisti';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.prijavadomponisti)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	obradiPrijavuDomPotvrda(){
		let url = 'prijave/admin/dom/obradi';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.prijavadomobradi)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						this.ucitajKandidate();
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	posaljistatuse(){
		let url = 'prijave/statusi/sendmail';

		this.loading = true;

		setTimeout(() => {				
		
			this.http.post(url, this.rList)
				.subscribe(data => {
					this.msg = data;
					this.loading = false;

					if (this.msg.id == 1) {
						//this.ucitajKandidate();
						M.toast({html:'Mailovi su uspješno poslati', displayLength : 4000});
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : 4000});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 500);
	}

	promijeniSort(){
		if (this.sortOption == 1){
			//sortirano po bodovima, sortiraj po vremenu
			this.prijave.sort( (a, b) => a.datumPrijave<b.datumPrijave?1:-1);
			
			this.sortOption = 2;
			//console.log(this.prijave);
		}
		else {
			this.prijave.sort( (a, b) => parseFloat(a.ukupnoBodovaStr)>parseFloat(b.ukupnoBodovaStr)?-1:1);
			this.sortOption = 1;
		}
	}

	getNazivDugmetaSort(){
		return this.sortOption==1?'Sortiraj po vremenu':'Sortiraj po bodovima';
	}

	ranglistaPDF(outType){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/ranglista';
        let kategorija = this.kategorije.find(item => item.id == this.idTipaPrijave);
        
		if (!kategorija)
			return;
        
        this.http.get(url, {params : {'idTipa' : kategorija.id, 'nazivTipa' : kategorija.naziv, 'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	ugovor(prijava){
        //console.log(this.ucenik);
        this.loading = true;
        let url = '';
        
		if (this.idTipaPrijave == '1' || this.idTipaPrijave == '2'){
			url = 'prijave/djaci/ugovor';
		}

        this.http.get(url, {params : {'idPrijave' : prijava.id}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'word');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }


	polazuextest(outType){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/polazuexttest';
        let studProgram = this.kategorije.find(item => item.id == this.idTipaPrijave);
        
		if (!studProgram)
			return;
        
        this.http.get(url, {params : {'outType' : outType}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	openhelp(){
		
        let url = 'upustvo';
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom fajla');
        });   
	}
}
